export const seo = ({
  title,
  description,
  keywords,
  image,
  canonical,
}: {
  title: string;
  description?: string;
  image?: string;
  keywords?: string;
  canonical?: string;
}) => {
  const tags = [
    { title },
    { name: "description", content: description },
    { name: "keywords", content: keywords },
    ...(canonical ? [{ rel: "canonical", href: canonical }] : []),
    { name: "youtube:title", content: title },
    {
      name: "youtube:description",
      content: `En çok yapmayı sevdiğim şeyi en iyi şekilde yapma ve yaptırma uğraşımı sizlerle paylaşıyorum.\n\n\"İşini en iyi yapan, vatanını en çok sevendir.\"\n– Mustafa Kemal Atatürk\n\nİş birliği ve sponsorluk teklifleri için: alicanatalay592@gmail.com\n\nPowerlifting branşında sikletimdeki rekorları toplamak için yarışıyorum ve aynı zamanda insanları da hedefleri doğrultusunda hazırlıyorum.`,
    },
    { name: "youtube:creator", content: "@atalaythecoach" },
    { name: "youtube:site", content: "@atalaythecoach" },
    { name: "youtube:url", content: "https://www.youtube.com/@atalaythecoach" },
    { name: "instagram:title", content: title },
    { name: "instagram:description", content: description },
    { name: "instagram:creator", content: "@atalaythecoach" },
    { name: "instagram:site", content: "@atalaythecoach" },
    {
      name: "instagram:url",
      content: "https://www.instagram.com/atalaythecoach/",
    },
    { name: "og:url", content: "https://atalaythecoach.com" },
    { name: "og:type", content: "website" },
    { name: "og:title", content: title },
    { name: "og:description", content: description },
    ...(image
      ? [
          { name: "twitter:image", content: image },
          { name: "twitter:card", content: "summary_large_image" },
          { name: "og:image", content: image },
          { name: "instagram:image", content: image },
          { name: "youtube:image", content: image },
        ]
      : []),
  ];

  return tags;
};
